import React, {createElement} from 'react';
import {Row, Col} from 'react-bootstrap';
import Markdown from 'components/Markdown';
import BoxedIsi from 'components/BoxedIsi';
import {css} from 'aphrodite';

import './styles.scss';

const Isi = ({settings, styleSheet}) => {
  if (!settings) {
    return null;
  }

  const linkRenderer = (props) => {
    if (settings.content.linkNewTab) {
      return (<a
        rel="noopener noreferrer"
        href={props.href}
        target="_blank"
        className={css(styleSheet.isiContentLink)}
      >
        {props.children}
      </a>);
    }

    return (
      <a
        href={props.href}
        className={css(styleSheet.isiContentLink)}
      >
        {props.children}
      </a>
    );
  };

  const boldRenderer = (props) => {
    return (<span className={css(styleSheet.isiContentBold)}>
      {props.children}
    </span>);
  };

  const headingRenderer = ({node, children, level}) => {
    const props = {};
    if (settings.anchorTaggedHeaderText && typeof(children) === 'string' && children.toLowerCase().includes(settings.anchorTaggedHeaderText)) {
      props.id = 'isi';
    }

    return createElement(
      `h${level}`,
      props,
      children
    );
  };

  // Any text inside a \t tag will be enclosed in a box.
  const codeBoxRenderer = (props) => {
    return <BoxedIsi enabled={true} settings={settings} source={props.children} styleSheet={styleSheet} />;
  };

  const markdownRenderers = {
    a: linkRenderer,
    strong: boldRenderer,
    h1: (props) => headingRenderer({...props, level: 1}),
    h2: (props) => headingRenderer({...props, level: 2}),
    h3: (props) => headingRenderer({...props, level: 3}),
    h4: (props) => headingRenderer({...props, level: 4}),
    h5: (props) => headingRenderer({...props, level: 5}),
    h6: (props) => headingRenderer({...props, level: 6}),
    code: codeBoxRenderer
  }

  return (
    <div data-component={'Isi'}>
      <Row>
        <Col {...(!settings.anchorTaggedHeaderText.length && {id: 'isi'})} className={css(styleSheet.isi)} sm={12}>
          <Markdown components={markdownRenderers}>
            {settings.content.markdown}
          </Markdown>
        </Col>
      </Row>
    </div>
  );
}

export default Isi;